const getters = {
  token: state => state.user.token,
  location: state => state.location.locationInfo,
  userInfo: state => state.user.userInfo,
  userInte: state => state.user.userInte,
  userSurplus: state => state.user.userSurplus,
  searchHistory: state => state.search.histories,
}

export default getters